<script>
  /**
   * @type {String} - button name
   */
  export let btnName = "button name"

  /**
   * @type {String} - button colour
   */
  export let btnclr = "blue"

  /**
   * @type {String} - left side icon name
   */
  export let leftIcon = ""

  /**
   * @type {String} - right side icon name
   */
  export let rightIcon = ""

  /**
   * @type {String} - right side icon name
   */
  export let size = "fit"

  export let disabled = false

  export let type = "button"
</script>

<button on:click {disabled} {type} class="{btnclr} flex min-h-[36px] w-{size} min-w-[128px] items-center justify-center gap-2 whitespace-nowrap rounded-md px-2 text-sm font-medium capitalize text-white hover:text-white focus:outline-none disabled:cursor-not-allowed lg:px-4">
  {#if leftIcon}
    <i class="fa-solid fa-{leftIcon}" />
  {/if}
  <span class="select-none md:block">{@html btnName}</span>
  {#if rightIcon}
    <i class="fa-solid fa-{rightIcon}" />
  {/if}
</button>

<style lang="postcss">
  .blue {
    @apply bg-blue-500 hover:bg-blue-600 active:bg-blue-500 disabled:bg-blue-300 disabled:hover:bg-blue-400 disabled:active:bg-blue-200;
  }
  .yellow {
    @apply bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-500 disabled:bg-yellow-300 disabled:hover:bg-yellow-400 disabled:active:bg-yellow-200;
  }
  .red {
    @apply bg-red-500 hover:bg-red-600 active:bg-red-500 disabled:bg-red-300 disabled:hover:bg-red-400 disabled:active:bg-red-200;
  }
  .green {
    @apply bg-green-500 hover:bg-green-600 active:bg-green-500 disabled:bg-green-300 disabled:hover:bg-green-400 disabled:active:bg-green-200;
  }
  .sky {
    @apply bg-sky-500 hover:bg-sky-600 active:bg-sky-500 disabled:bg-sky-300 disabled:hover:bg-sky-400 disabled:active:bg-sky-200;
  }
</style>
